import { FC } from 'react';
import { sanitizeHtml } from '@new/common/lib/sanitize';
import { BookOpen, ExternalLink } from 'lucide-react';

interface LessonReadingTabProps {
  lesson: Lesson;
}

export const LessonReadingTab: FC<LessonReadingTabProps> = ({ lesson }) => {
  const readings = lesson.readings || [];

  const handleOpenReading = (url: string) => {
    window.open(url, '_blank');
  };

  if (readings.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 gap-3">
        <BookOpen size={48} className="text-(--neutral-black-NB400)" />
        <p className="[font-size:var(--fs-p4)]! text-(--neutral-black-NB600)! text-center">
          No readings available for this lesson.
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6">
      {readings.map((reading: any) => (
        <div key={reading.id} className="flex flex-col gap-4">
          <div className="bg-(--neutral-black-NB50) p-4 rounded-lg">
            <h3 className="[font-size:var(--fs-p3)]! text-(--neutral-black-NB1000)! font-bold m-0!">
              {reading.title || reading.name}
            </h3>
          </div>

          {reading.description && (
            <div className="flex flex-col gap-3">
              <h4 className="[font-size:var(--fs-p4)]! text-(--neutral-black-NB1000)! font-semibold m-0!">
                Reading description
              </h4>
              <div
                className="[font-size:var(--fs-p4)]! text-(--neutral-black-NB900)! [line-height:150%]"
                dangerouslySetInnerHTML={{ __html: sanitizeHtml(reading.description) }}
              />
            </div>
          )}

          {reading.exampleFileUrl && (
            <div className="flex flex-col gap-2">
              <h4 className="[font-size:var(--fs-p4)]! text-(--neutral-black-NB1000)! font-semibold m-0!">
                Reading files
              </h4>
              <div
                onClick={() => handleOpenReading(reading.exampleFileUrl)}
                className="flex items-center gap-3 p-3 border-2 border-(--neutral-black-NB100) rounded-lg cursor-pointer hover:border-(--primary-O900) transition-colors"
              >
                <BookOpen size={20} className="text-(--primary-O900)" />
                <p className="[font-size:var(--fs-p4)]! text-(--neutral-black-NB900)! m-0! flex-1">
                  {reading.title || reading.name}
                </p>
                <ExternalLink size={16} className="text-(--primary-O900)" />
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
